import React from 'react'
import { useFormStatus } from 'react-dom'
import classNames from 'classnames'

import { SubmitButtonProps } from '@/submit-button/SubmitButton.schema'

import Button from '@/button/Button'

const SubmitButton = (props: SubmitButtonProps): JSX.Element => {
    const className = classNames('submit-button', props.className)

    const { pending: formPending } = useFormStatus()

    return (
        <Button
            className={className}
            type='submit'
            label={props.label}
            icon='wonky-arrow-right'
            iconPosition='right'
            color='yellow'
            size='large'
            isPending={props.isUploading}
            disabled={formPending || props.disabled || props.isUploading}
        />
    )
}

export default SubmitButton